import socket from '@/plugins/socket'

export default {
  namespaced: true,
  state: {
    list: []
  },
  mutations: {
    init: (state, data) => { state.list = data.sort((a, b) => a.nameFr.localeCompare(b.nameFr)) }
  },
  actions: {
    init (state) {
      const parameters = {
        include: [
          { column: 'clubId' }
        ]
      }
      socket.get('SportSportTeam', 'Sport/Team/init', parameters)
    }
  },
  getters: {
    list: (state) => state.list,
    search: (state) => (value, eventUnitId, sportId) => state.list.filter(
      item => (item.eventUnitId === eventUnitId || item.sportId === sportId) &&
        (item.id === parseInt(value) || item.nameFr.toLowerCase().indexOf(value.toLowerCase()) > -1)
    ),
    get: (state) => (teamId) => state.list.find(item => item.id === teamId)
  }
}
